"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.occupation = exports.Occupation = void 0;
const schema_1 = require("../schema");
var Occupation;
(function (Occupation) {
    Occupation["Doctor"] = "DOCTOR";
    Occupation["Assistant"] = "ASSISTANT";
    Occupation["Other"] = "OTHER";
})(Occupation || (exports.Occupation = Occupation = {}));
exports.occupation = schema_1.Schema.enum([
    Occupation.Doctor,
    Occupation.Assistant,
    Occupation.Other
]);
